import type { GetFamilyIfManyTagsParams } from './types';

/**
 * Validates input parameters for the getFamilyIfManyTags function
 *
 * @param params - Parameters to validate
 * @throws Error if validation fails
 */
export function validateGetFamilyIfManyTagsParams(params: GetFamilyIfManyTagsParams): void {
  const { tagsSubset, allTags } = params;

  if (!Array.isArray(tagsSubset)) {
    throw new Error('tagsSubset must be an array');
  }

  if (!Array.isArray(allTags)) {
    throw new Error('allTags must be an array');
  }

  if (tagsSubset.length === 0) {
    throw new Error('tagsSubset cannot be empty');
  }
}
